import ProcessFollowup from '@/pages/Processes/ProcessFollowup.vue'
import FollowupDetails from '@/pages/Processes/FollowupDetails.vue'
import InitiateProcess from '@/pages/Processes/InitiateProcess.vue'
import RequestExecuteSurvey from '@/pages/Processes/RequestExecuteSurvey.vue'
import RequestInquiry from '@/pages/Processes/RequestInquiry.vue'
import RequestStrategicSatisfaction from '@/pages/Processes/RequestStrategicSatisfaction.vue'
import RequestOperationalIndicator from '@/pages/Processes/RequestOperationalIndicator.vue'
import RequestAdditionalAnalysis from '@/pages/Processes/RequestAdditionalAnalysis.vue'
import RequestScientificConsultation from '@/pages/Processes/RequestScientificConsultation.vue'
import RequestFocusGroups from '@/pages/Processes/RequestFocusGroups.vue'

export default [

	{
		name: 'request-strategic-satisfaction',
		path: '/processes/request-strategic-satisfaction',
		component: RequestStrategicSatisfaction,
		meta: { secure: true }
	},

	{
		name: 'request-operational-indicator',
		path: '/processes/request-operational-indicator',
		component: RequestOperationalIndicator,
		meta: { secure: true }
	},

	{
		name: 'request-additional-analysis',
		path: '/processes/request-additional-analysis',
		component: RequestAdditionalAnalysis,
		meta: { secure: true }
	},

	{
		name: 'request-scientific-consultation',
		path: '/processes/request-scientific-consultation',
		component: RequestScientificConsultation,
		meta: { secure: true }
	},

	{
		name: 'request-focus-groups',
		path: '/processes/request-focus-groups',
		component: RequestFocusGroups,
		meta: { secure: true }
	},

	{
		name: 'request-execute-survey',
		path: '/processes/request-execute-survey',
		component: RequestExecuteSurvey,
		meta: {
			secure: true
		}
	},

	{
		name: 'request-inquiry',
		path: '/processes/request-inquiry',
		component: RequestInquiry,
		meta: {
			secure: true
		}
	},

	{
		name: 'followup',
		path: '/processes/followup',
		component: ProcessFollowup,
		meta: {
			secure: true
		}
	},
	{
		name: 'followup-details',
		path: '/processes/followup-details/:processInstanceId',
		component: FollowupDetails,
		meta: {
			secure: true
		}
	},
	{
		name: 'initiate-process',
		path: '/processes/initiate-process/:workflowId',
		component: InitiateProcess,
		meta: {
			secure: true
		}
	},

]